import React from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import loginBg from "../../../../media/images/bg/bg-16.png"; 
import Login from "./Login";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import { useRegisterState } from "../../../components/contexts/authContext/AuthContextProvider";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";

export function AuthPage() {
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-20  p-lg-10"
            // style={{
            //   backgroundImage: `url(${loginBg})`,
            // }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <Link to="/" className="flex-column-auto mt-5"></Link>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              {/* <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h3 mb-5 text-white text-center">
                  صنایع دستی آقاجانی
                </h3>
                <p className="font-weight-lighter text-white opacity-80"></p>
              </div> */}
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  کلیه حقوق این سایت محفوظ است
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="flex-row-fluid d-flex flex-column position-relative py-1 px-7 overflow-hidden">
            <div className="d-flex flex-column-fluid flex-center ">
              <Switch>
                <ContentRoute path="/auth/login" component={Login} />

                <Redirect from="/auth" exact={true} to="/auth/login" />
              </Switch>
              {/* {template} */}
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div
                className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2"
                style={{ fontSize: "10px" }}
              >
                کلیه حقوق این سامانه متعلق به صنایع دستی آقاجانی می‌باشد.
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
